<template>
  <v-container fluid align="top">
    <!-- name/title card -->
    <v-row>
      <v-col>
        <v-card>
          <v-card-title class="headline font-weight-medium">
            Account & Subscriptions
            <v-spacer />
          </v-card-title>
          <v-card-subtitle class="title font-weight-regular">{{getOrg}}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <!-- Account info -->
      <v-col>
        <v-card :loading="loading">
          <v-card-title>
            ACCOUNT INFORMATION
            <v-spacer></v-spacer>
            <v-btn icon @click="onEditAccountClick()" color="blue">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-map-marker</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Address</div>
                {{this.getAccount.address}}
              </v-col>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-phone</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Phone</div>
                {{this.getAccount.phone}}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-email</v-icon>
              </v-col>
              <v-col>
                <div class="overline">City</div>
                {{this.getAccount.city}}
              </v-col>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-email</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Billing Zip</div>
                {{this.getAccount.zip}}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-clock</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Timezone</div>
                {{this.getAccount.timeZone}}
              </v-col>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-email</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Since</div>
                {{this.getAccount.created}}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Subscription info -->
      <!-- TEMPORARILY DISABLED -->
      <v-col v-if="false">
        <v-card :loading="loading">
          <v-card-title>
            SUBSCRIPTION
            <v-spacer />
            <v-btn icon @click="openSubscriptionEdit()">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle class="title font-weight-regular">{{this.getAccount.subTitle}}</v-card-subtitle>
          <v-card-text>
            <!-- Trial account -->
            <v-sheet v-if="this.isTrial">
              <v-row>
                <v-col>
                  <div class="overline">Description</div>
                  TRIAL
                </v-col>
                <v-col>
                  <div class="overline">Expires</div>
                  {{this.getAccount.trialExpiration}}
                </v-col>
              </v-row>
            </v-sheet>
            <!-- Subscribed account -->
            <v-sheet v-else>
              <v-row>
                <v-col>
                  <div class="overline">Description</div>
                  {{this.getAccount.subDescription}}
                </v-col>
                <v-col>
                  <div class="overline">Billing Period</div>
                  {{this.getAccount.subInvoiceStart}} - {{this.getAccount.subInvoiceEnd}}
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <div class="overline">Status</div>
                  <div v-if="this.getAccount.subPaid" class="green--text font-weight-medium">PAID</div>
                  <div v-else-if="this.getAccount.subPaid == false" class="red--text font-weight-medium">OVERDUE</div>
                  <div v-else class="font-weight-medium">NA</div>
                </v-col>
              </v-row>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card :loading="loading">
          <v-card-title>
            PAYMENT METHOD
            <v-spacer />
            <v-btn v-if="!this.isTrial" icon @click="openPaymentMethodEdit()" color="blue">
              <v-icon>mdi-wrench</v-icon>
            </v-btn>
          </v-card-title>

          <v-sheet v-if="this.isTrial">
            <v-card-text>
              Subscribe to add a payment method.
            </v-card-text>
          </v-sheet>


          <!-- <v-sheet v-else-if="this.getAccount.includesCard"> -->
          <!-- User can add a payment method if one doesn't already exist -->
          <v-sheet v-else-if="this.getAccount.cardLast4">
            <v-card-text>
              <v-row>
                <v-col cols="1">
                  <v-icon>{{getCardIcon(this.getAccount.cardType)}}</v-icon>
                </v-col>
                <v-col>
                  <h3>{{this.getAccount.cardLast4}}</h3>
                  <p>Expires {{this.getAccount.cardExpiration}}</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-sheet>

          <!-- <v-sheet v-else> -->
            <!-- no card -->
          <!-- </v-sheet> -->

        </v-card>
      </v-col>
    </v-row>

    <EditAccount :account="this.getAccount" :loading="modalLoading" :visible="isEditAccountVisible" :error="error" v-on:onConfirmed="onEditAccountConfirmed" v-on:onCancelled="onEditAccountCancelled" />

    <UpdatePaymentMethod :visible="isUpdatePaymentMethodVisible" v-on:onConfirmed="onPaymentMethodUpdateConfirmed" v-on:onCancelled="onPaymentMethodUpdateCancelled" />

    <UpdateSubscription :loading="modalLoading" :currentPrice="this.price" :visible="isUpdateSubscriptionVisible" v-on:onConfirmed="onUpdateSubscriptionConfirmed" v-on:onCancelled="onUpdateSubscriptionCancelled" />

    <Notification :open="notificationOpen" :message="notificationMessage" v-on:onConfirmed="onConfirmNotification" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EditAccount from "../../modals/EditAccount";
import UpdatePaymentMethod from "../../modals/UpdatePaymentMethod";
import UpdateSubscription from "../../modals/UpdateSubscription";
import Notification from "../../components/Notification";
export default {
  name: "Account",
  components: {
    EditAccount,
    UpdatePaymentMethod,
    UpdateSubscription,
    Notification
  },
  computed: {
    ...mapGetters(["getAccount", "getOrg", "getPrices", "isTrial"])
  },
  data() {
    return {
      loading: true,
      isEditAccountVisible: false,
      isUpdatePaymentMethodVisible: false,
      isUpdateSubscriptionVisible: false,
      modalLoading: false,
      notificationOpen: false,
      notificationMessage: "",
      error: "",
      price: null
    };
  },
  methods: {
    ...mapActions([
      "fetchAccount",
      "updateAccount",
      "setGlobalAlert",
      "updatePaymentMethod",
      "updateSubscription",
      "loadWebConfig"
    ]),
    getCardIcon(cardType) {
      if (!cardType) return;
      if (cardType.toLowerCase() === "visa") {
        return "fab fa-cc-visa";
      } else if (cardType.toLowerCase() === "mastercard") {
        return "fab fa-cc-mastercard";
      } else if (cardType.toLowerCase() === "american express") {
        return "fab fa-cc-amex";
      } else if (cardType.toLowerCase() === "discover") {
        return "fab fa-cc-discover";
      } else {
        return "far fa-credit-card";
      }
    },
    onConfirmNotification: function() {
      this.notificationOpen = false;
    },
    // OPEN MODALS
    onEditAccountClick: function() {
      this.isEditAccountVisible = true;
    },
    openPaymentMethodEdit() {
      this.isUpdatePaymentMethodVisible = true;
    },
    openSubscriptionEdit() {
      this.price = this.getPrice(this.getAccount.subscription);
      this.isUpdateSubscriptionVisible = true;
    },

    // MODAL CANCELS
    onEditAccountCancelled() {
      this.isEditAccountVisible = false;
      this.error = null;
    },
    onPaymentMethodUpdateCancelled() {
      this.isUpdatePaymentMethodVisible = false;
    },
    onUpdateSubscriptionCancelled() {
      this.isUpdateSubscriptionVisible = false;
    },

    // MODAL CONFIRMS
    async onEditAccountConfirmed(account) {
      this.modalLoading = true;
      try {
        await this.updateAccount(account);
        this.isEditAccountVisible = false;
      } catch (e) {
        this.error = this.$t("error.general.unhandled");
      }
      this.modalLoading = false;
    },
    onPaymentMethodUpdateConfirmed() {
      this.isUpdatePaymentMethodVisible = false;
      this.setGlobalAlert({
        alert: true,
        color: 'black',
        alertMessage: this.$t("view.account.paymentMethodUpdate.success")
      });
    },
    onUpdateSubscriptionConfirmed(newPrice) {
      this.modalLoading = true;
      var req = {};
      req.id = newPrice;
      this.updateSubscription(req)
        .then(() => {
          this.notificationMessage =
            "Your subscription plan has been succesfully changed and will reflect on your next invoice. For subscription upgrades, a prorated credit for the currect month has been applied to the next invoice";
          this.notificationOpen = true;
        })
        .catch(() => {
          this.setGlobalAlert({
            alert: true,
            color: 'red',
            alertTitle: "Error",
            alertMessage:
              "There was a problem updating your subscription plan. Please try again "
          });
        })
        .finally(() => {
          this.modalLoading = false;
          this.isUpdateSubscriptionVisible = false;
        });
    },
    getPrice(priceId) {
      return this.getPrices(true).find(function(price) {
        return price.id === priceId;
      });
    }
  },
  props: {},
  created() {
    this.fetchAccount()
      .catch(() => {
        this.setGlobalAlert({
          alert: true,
          color: 'red',
          alertTitle: "There's been a problem",
          alertMessage:
            "Unable to retreive account information, support has been notified. Please try again shortly. "
        });
      })
      .finally(() => {
        this.loading = false;
      });

    this.loadWebConfig()
      .catch(() => {
        this.error = true;
        console.error("Error loading web config");
      });
  }
};
</script>

<style>
</style>